<template>
  <v-menu v-if="showSelector" offset-y content-class="elevation-1">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="language-selector-button" small text v-bind="attrs" v-on="on">
        <img v-if="showFlagIcon" :src="getFlagSrc(flags.current)" width="22" />
        <span v-if="showFlagName" class="ml-2">
          {{ flags.current }}
        </span>
        <v-icon class="ml-1 mr-0 pr-0">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list nav>
      <v-list-item
        v-for="item in flags.additional"
        :key="item"
        class="py-0 pl-3 pr-0 language-selector-list-item"
        @click="switchLang(item)"
      >
        <v-list-item-title>
          <!-- <v-img :src="getFlagSrc(item)" width="18px" /> -->
          <div class="flag-list-item">
            <img :src="getFlagSrc(item)" width="20" />
            <span v-if="showFlagName" class="ml-2">
              {{ item }}
            </span>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

const LANGUAGES = ['en', 'es']

export default {
  props: {
    showSelector: {
      type: Boolean,
      default: true,
    },
    showFlagIcon: {
      type: Boolean,
      default: true,
    },
    showFlagName: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(['language']),
    flags() {
      const current = this.$i18n.locale
      const additional = LANGUAGES.filter((language) => language !== current)
      return {
        current,
        additional,
      }
    },
  },
  mounted() {
    this.$i18n.locale = this.language || process.env.VUE_APP_I18N_LOCALE || 'en'
  },
  methods: {
    ...mapMutations({
      setLanguage: 'SET_LANGUAGE',
    }),
    switchLang(item) {
      this.setLanguage(item)
      this.$i18n.locale = item
    },
    getFlagSrc(flag) {
      if (!flag) return null
      try {
        return require(`@/assets/flag/flag_${flag.toLowerCase()}.png`)
      } catch (error) {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
.language-selector-button {
  font-size: 14px !important;
  font-weight: 300;
}
.language-selector-list-item {
  text-transform: uppercase;
  font-size: 14px !important;
  font-weight: 300;
}
.flag-list-item {
  display: flex;
  align-items: center;
  font-size: 14px !important;
  font-weight: 300;
}
</style>
